import { render } from "./TransactionPreview.vue?vue&type=template&id=44cf2584"
import script from "./TransactionPreview.vue?vue&type=script&lang=js"
export * from "./TransactionPreview.vue?vue&type=script&lang=js"

import "./TransactionPreview.vue?vue&type=style&index=0&id=44cf2584&lang=sass"

import exportComponent from "/Users/trifjolngjela/Projects/home-budget/home-budget-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
